<template>
  <div>
    <div class="d-flex flex-wrap align-items-center">
      <div class="mr-auto">
        <p class="text-uppercase text-dark font-weight-bold mb-1">
          Recebimento Total
        </p>
      </div>
    </div>
    <div class="d-flex flex-wrap align-items-center">
      <div class="text-nowrap text-dark font-size-50 font-weight-bold">
        {{ localTotal | money }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ReceivementTotal",
  props: {
    total: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      localTotal: 0
    };
  },
  watch: {
    total(nV) {
      this.localTotal = nV;
    }
  },
  mounted() {
    this.localTotal = this.total;
  }
};
</script>
